<template>
  <!--基本信息的基本姓名区 -->
  <!-- acCardStudentCodeType//考号填写模式：0-填涂考号， 1-条码 ，2-手写考号 -->
  <div style="position: relative;border: 1px solid #000000; border-bottom: none" @mouseover="showBasicsInfoEdit = true" @mouseleave="showBasicsInfoEdit = false">
    <div class="basics_info_edit" @click="handleBasicsEdit" v-show="showBasicsInfoEdit">
      <i class="el-icon-edit-outline" style="font-size: 18px; color: #fff"></i>
    </div>
    <template v-if="answerSheet.acCardPanes != '3'" style="height: 100%">
      <div
        class="basics-info"
        v-if="
          answerSheet.acCardStudentCodeType == 0
          /*  &&answerSheet.acCardExamNumber < 9 **/
        "
      >
       <div class="i-name">{{basicsCheckList[0]}}</div>
          <div class="i-cont" style="border-right: 0; flex-grow: 0.45"></div> 
           <div class="i-name">{{basicsCheckList[1]}}</div>
          <div class="i-cont" style="border-right: 0; flex-grow: 0.45"></div>
        <div class="basics-info" >
          <div class="i-name">{{basicsCheckList[2]}}</div>
          <div class="i-cont" style="border-right: 0; flex-grow: 0.45" v-if="basicsCheckList[2]"></div> 
           <div class="i-name">{{basicsCheckList[3]}}</div>
          <div class="i-cont" style="border-right: 0; flex-grow: 0.45" v-if="basicsCheckList[3]"></div>
        </div>
      </div>
      <div class="basics-info" v-else>
        <div style="display: flex" v-for="(item,index) in basicsCheckList" :key="index"> 
         <div class="i-name">{{item}}</div>
         <div class="i-cont"></div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="basics-info-left"
        v-if="answerSheet.acCardStudentCodeType === 0 || answerSheet.acCardStudentCodeType === 1"
      >
        <div
          class="i-item"
          style="justify-content: start; margin-left: 14px; margin-top: 22px"
          v-for="(item,index) in basicsCheckList" :key="index"
        >
          <div class="i-name">{{item}}</div>
          <div class="i-cont" style="flex-grow: 0.8"></div>
        </div>
        <!-- <div
          class="i-item"
          style="justify-content: start; margin-left: 14px; margin-top: 22px"
        >
          <div class="i-name">学校</div>
          <div class="i-cont" style="flex-grow: 0.8"></div>
        </div>
        <div
          class="i-item"
          style="justify-content: start; margin-left: 14px; margin-top: 22px"
        >
          <div class="i-name">班级</div>
          <div class="i-cont" style="flex-grow: 0.8"></div>
        </div>
        <div
          class="i-item"
          style="justify-content: start; margin-left: 14px; margin-top: 22px"
        >
          <div class="i-name">考号</div>
          <div class="i-cont" style="flex-grow: 0.8"></div>
        </div> -->
      </div>
      <div class="basics-info" v-else>
        <div style="display: flex" v-for="(item,index) in basicsCheckList" :key="index"> 
        <div class="i-name">{{item}}</div>
        <div class="i-cont" :style="`min-width: ${basicsCheckList && basicsCheckList.length == 4 ? '75px' : '90px'}`"></div>
        </div>
      </div>
    </template>
    <ModalBasicsEdit v-model="modalBasicsEditV"/>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import ModalBasicsEdit from '../../views/components/card/modal-basics-info'
//基础信息区
export default {
  name: "basicsInfo",
  props: {},
  components:{
    ModalBasicsEdit
  },
  computed: {
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
  ...mapState("card", {
    basicsCheckList: (state) => state.basicsCheckList, //选中的信息
 }),
    // oneTwoBasicsCheckList() {
    //   return this.basicsCheckList.splice(0,2);
    // },
    // threeFourBasicsCheckList() {
    //   return this.basicsCheckList.splice(3, 4)
    // },
    contW() {
      let w;
      if (this.answerSheet.acCardStudentCodeType == 1) {
        w = this.pageCellSize[1] - 300 - 1 - 41 - 20;
      } else {
        w =
          this.pageCellSize[1] -
          this.answerSheet.acCardExamNumber * 28 -
          41 -
          20;
      }
      return w;
    },
  },
  data() {
    return {
      modalBasicsEditV: false,
      showBasicsInfoEdit: false,
    };
  },
  methods:{
    handleBasicsEdit() {
      this.modalBasicsEditV = true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
.basics-info {
  display: flex;
  flex-flow: row wrap;
  background: #fff;
  justify-content: flex-start;
  min-width: 264px;
  width: 100%;
  .box {
    flex: 1;
  }
  .i-name {
    // background: #f2f2f2;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    // border-right: 1px solid #000000;
    position: relative;
  }
  .i-cont {
    border-bottom: 1px solid #000;
    min-width: 90px;
    flex-grow: 0.26;
    margin-left: 6px;
    margin-bottom: 6px;
    &:last-child {
      border-right: 0;
    }
  }
}
.basics-info-left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .box {
    flex: 1;
  }
  .i-item {
    display: flex;
    justify-content: center;
  }
  .i-name {
    // background: #f2f2f2;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    // border-right: 1px solid #000000;
    position: relative;
  }
  .i-cont {
    border-bottom: 1px solid #000;
    min-width: 90px;
    flex-grow: 0.5;
    margin-left: 2px;
    margin-bottom: 8px;
    &:last-child {
      border-right: 0;
    }
  }
}

  .basics_info_edit{
    position: absolute;
    display: flex;
    width: 30px;
    height: 30px;
    top: 7px;
    right: 7px;
    background: #409eff;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    box-shadow: 2px 2px 6px #3031339e;
    cursor: pointer;
  }
</style>
